import gql from 'graphql-tag';

import type { AllInstructionsData } from 'src/data/generation';
import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type {
  BackendCustomerPersonaConnection,
  BackendMutationExtractBriefPersonasArgs,
} from 'src/types/backend';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ExtractBriefPersonas(
    $brief: BriefInput!
    $projectId: ID!
    $brandVoiceId: ID
    $promptImageId: ID
    $promptDocumentId: ID
    $freestyleToolAllInstructionsData: JSON
    $urlExtractions: [UrlExtractionInput!]
    $language: String
  ) {
    extractBriefPersonas(
      brief: $brief
      projectId: $projectId
      brandVoiceId: $brandVoiceId
      promptImageId: $promptImageId
      promptDocumentId: $promptDocumentId
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
      urlExtractions: $urlExtractions
      language: $language
    ) {
      edges {
        node {
          ...CustomerPersona
        }
      }
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

type Variables = Override<
  BackendMutationExtractBriefPersonasArgs,
  {
    freestyleToolAllInstructionsData?: AllInstructionsData;
  }
>;
type Result = BackendCustomerPersonaConnection;

export const extractBriefPersonas = async (
  { freestyleToolAllInstructionsData, ...rest }: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      freestyleToolAllInstructionsData: stringifyIfPresent(freestyleToolAllInstructionsData),
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data) || [];
};
